module.exports = __webpack_public_path__ + "static/media/JUSTSans-Regular.9fe953cd.woff";